import { FormKitNode } from '@formkit/core';
/**
 * Custom plugin to integrate spinner into the Vue Formkit library.
 * Spinner will be shown in the form input 'suffixIcon' slot.
 *
 * To make this solution work, this code leverages Formkit Schemas.
 * Read more about Schemas: https://formkit.com/essentials/schema
 *
 */
const enabledInputType = ['text'];

export default (node: FormKitNode) => {
  // Add trim to node, default to true; e.g: :trim="false"
  node.addProps(['trim']);

  node.on('mounted', () => {
    try {
      if (node.props.trim === false || (node.context?.type && !enabledInputType.includes(node.context.type))) return;

      node.props.attrs.onBlur = (evt: any) => {
        try {
          if (typeof evt.target.value == 'string') {
            node.input(evt.target.value.trim());
          }
        } catch {
          // ignored
        }
      };
    } catch {
      // ignored
    }
  });
};
